export default __webpack_public_path__ + "static/08b57253-2e0d-4c12-9c57-107f6c67bc49-9f91cf0edf046e639c5669c541a206f1.woff2";